export const INITIAL_FORMS_PERIOD_QUERY = `&period=annual&year=${new Date().getFullYear()}`;
